module.exports = __webpack_public_path__ + "static/media/other.7fd8bf54.png";